module.exports = __webpack_public_path__ + "img/inspection.da6f24f.jpg";